import numeral from 'numeral';

export const formatNumberToCash = (num) => {
  return numeral(num).format('0,0.00$');
};

export const formatNumberToCash2 = (num) => {
  return numeral(num).format('$0,0.00');
};

export const formatNumber = (num) => {
  return numeral(num).format('0,0');
};

export const formatNumber2 = (num) => {
  if (typeof num !== 'number') num = parseFloat(num);
  if (isNaN(num)) return '0.00';

  const truncated = Math.trunc(num * 100) / 100;
  const [int, dec = ''] = truncated.toString().split('.');
  return numeral(int).format('0,0') + '.' + dec.padEnd(2, '0');
};
